import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib';
import * as actions from './get-flights-result.actions';
import { GetFlightsResultState } from './get-flights-result.state';

/**
 * getFlightsResult initial state
 */
export const getFlightsResultInitialState: GetFlightsResultState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for GetFlightsResult Store
 */
export const getFlightsResultReducerFeatures: ReducerTypes<GetFlightsResultState, ActionCreator[]>[] = [
  on(actions.setGetFlightsResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateGetFlightsResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetGetFlightsResult, () => getFlightsResultInitialState),

  on(actions.cancelGetFlightsResultRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failGetFlightsResult, (state, payload) => asyncStoreItemAdapter.failRequest(state, payload.requestId)),

  on(actions.setGetFlightsResultFromApi, actions.updateGetFlightsResultFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * GetFlightsResult Store reducer
 */
export const getFlightsResultReducer = createReducer(getFlightsResultInitialState, ...getFlightsResultReducerFeatures);
